import type { EventDto } from "@mmm/contracts";
import { EVENT_TYPE_COLORS } from "../../constants.js";

interface EventChipProps {
  event: EventDto;
  onClick?: () => void;
  readOnly?: boolean;
}

export function EventChip({ event, onClick, readOnly = false }: EventChipProps) {
  const colors = EVENT_TYPE_COLORS[event.type];

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={readOnly}
      className="mmm-event-chip"
      style={{
        color: colors.text,
        background: colors.bg,
      }}
      title={event.title}
    >
      {event.title}
    </button>
  );
}
